module.exports = __webpack_public_path__ + "img/菜单_logo_black@3x.6259173c.png";